import { useId as useReactId } from 'react'

/** Stable, SSR-safe id with a readable prefix — used to wire aria-* relationships. */
export function useDomId(prefix: string, provided?: string) {
  const generated = useReactId()
  return provided ?? `${prefix}-${generated.replace(/:/g, '')}`
}
